import { Component } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { protectDisplayLanguage } from '@/lib/displayLanguage';

export class AppErrorBoundary extends Component {
  state = { failed: false, diagnostic: '' };

  static getDerivedStateFromError() { return { failed: true }; }

  componentDidCatch(error, info) {
    console.error('Logyra display error', error, info.componentStack);
    // Only technical categories: no account, document, token, URL parameters or
    // raw error message (which might contain personal data). Never sent remotely.
    const known = ['TypeError', 'RangeError', 'ReferenceError', 'SyntaxError', 'NotFoundError', 'Error'];
    const kind = known.includes(error?.name) ? error.name : 'Error';
    const match = (info.componentStack || '').match(/\bat\s+([A-Za-z][A-Za-z0-9_]{0,79})(?:\s|\()/);
    const scope = typeof window !== 'undefined' && window.location.pathname.endsWith('/caisse') ? 'CAISSE' : 'APP';
    const changedDom = error?.name === 'NotFoundError' && /removeChild|insertBefore/.test(error?.message || '');
    // Category only: do not expose raw messages, account data or browser storage.
    this.setState({ diagnostic: `${scope}-609 · ${changedDom ? 'DOM_MODIFIE · ' : ''}${kind} · ${match?.[1] || 'affichage'}` });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="min-h-screen bg-gray-50 flex items-center justify-center p-6 notranslate" translate="no" data-testid="app-display-error">
      <div role="alert" className="w-full max-w-md space-y-4 text-center">
        <AlertTriangle className="w-10 h-10 text-amber-600 mx-auto" />
        <h1 className="font-heading text-xl text-brand-blue" data-testid="app-display-error-title">L’affichage a été interrompu</h1>
        <p className="text-sm text-gray-600" data-testid="app-display-error-message">Les documents déjà enregistrés sont conservés. Vous pouvez reprendre sans vous déconnecter.</p>
        {this.state.diagnostic && <details className="text-xs text-gray-600" data-testid="app-display-error-details">
          <summary className="cursor-pointer" data-testid="app-display-error-details-toggle">Informations techniques</summary>
          <code className="block mt-2 break-words" data-testid="app-display-error-code">{this.state.diagnostic}</code>
        </details>}
        <Button onClick={() => { protectDisplayLanguage(); window.location.reload(); }} className="bg-brand-blue text-white" data-testid="app-display-error-retry">
          <RefreshCw className="w-4 h-4 mr-2" /> Reprendre
        </Button>
      </div>
    </main>;
  }
}